import { lazy, type ComponentType } from 'react';

/**
 * React.lazy for a page module that uses a named export, so each page becomes
 * its own chunk without changing how the page files export.
 */
export function lazyPage<M extends Record<string, unknown>, K extends keyof M & string>(
  load: () => Promise<M>,
  name: K,
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return lazy(() => load().then((m) => ({ default: m[name] as ComponentType<any> })));
}
